import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, type ReactElement } from "react"

import { SelectItemTemplate } from "../../../components/MenuGroups/constants"
import { TextAlign } from "../../enums"
import { textAlignDataMapping } from "../mappings"

type TextAlignDropdownSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	ComponentPropsWithRef<typeof Menu.SelectGroup<TextAlign>> & {
		alignments: TextAlign[]
		children: ReactElement
	}

export const TextAlignDropdownSelect = memo<TextAlignDropdownSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,
		// TextAlignSelectGroup props
		alignments,
		value,
		defaultValue,
		onValueChange,
		required,
		...rest
	} = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				{/* @ts-expect-error cant have invalid mismatch */}
				<Menu.SelectGroup<TextAlign>
					required={required}
					value={value}
					defaultValue={defaultValue}
					onValueChange={onValueChange}
				>
					{alignments.map((alignment) => {
						const { icon, label } = textAlignDataMapping[alignment]

						return (
							<SelectItemTemplate<TextAlign> key={alignment} value={alignment}>
								<LuIcon icon={icon} />
								{label}
							</SelectItemTemplate>
						)
					})}
				</Menu.SelectGroup>
			</Menu.Content>
		</Menu.Root>
	)
})
TextAlignDropdownSelect.displayName = "TextAlignDropdownSelect"
